var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16665 6.99998V7.49998H7.66665H9.83331V7.83331H6.83331V4.16665H7.16665V6.99998ZM6.99998 13.1666C3.59412 13.1666 0.833313 10.4058 0.833313 6.99998C0.833313 3.59412 3.59412 0.833313 6.99998 0.833313C10.4058 0.833313 13.1666 3.59412 13.1666 6.99998C13.1666 10.4058 10.4058 13.1666 6.99998 13.1666ZM6.99998 12.8333C8.54708 12.8333 10.0308 12.2187 11.1248 11.1248C12.2187 10.0308 12.8333 8.54708 12.8333 6.99998C12.8333 5.45288 12.2187 3.96915 11.1248 2.87519C10.0308 1.78123 8.54708 1.16665 6.99998 1.16665C5.45288 1.16665 3.96915 1.78123 2.87519 2.87519C1.78123 3.96915 1.16665 5.45288 1.16665 6.99998C1.16665 8.54708 1.78123 10.0308 2.87519 11.1248C3.96915 12.2187 5.45288 12.8333 6.99998 12.8333Z",
    fill: "#00213F",
    stroke: "#00213F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.17a5c20fc918657ed452bd154589c304.svg";
export { ForwardRef as ReactComponent };